import config from "../config";
import { SimulatedScannedBarcode, ModuleBooleanSensorValue, MotorDto } from "../Model/Simulation";
import { sendGetRequest, sendPostRequest } from "./../Utility/FetchUtils";
import { EBooleanSensorType } from "../Model/EBooleanSensorType";

export default class SimulationApi {
  static BASE_URL = config.SERVICE_URL + "/Simulation";

  static readBooleanSensors(moduleIdentifier: string) {
    const url = `${this.BASE_URL}/boolean-sensor/${moduleIdentifier}`;
    return sendGetRequest<ModuleBooleanSensorValue[]>(url);
  }

  static toggleBooleanSensor(moduleIdentifier: string, type: EBooleanSensorType) {
    const url = `${this.BASE_URL}/:toggle-boolean-sensor/${moduleIdentifier}/${type}`;
    return sendPostRequest(url);
  }

  static getSimulatedMotors(moduleIdentifier: string) {
    const url = `${this.BASE_URL}/simulated-motor/${moduleIdentifier}`;
    return sendGetRequest<MotorDto[]>(url);
  }

  static triggerMotorCrash(motor: MotorDto) {
    const url = `${this.BASE_URL}/:trigger-simulated-motor-crash`;
    return sendPostRequest(url, motor);
  }

  static getSimulatedScannedBarcode() {
    const url = `${this.BASE_URL}/simulated-scanned-barcode`;
    return sendGetRequest<SimulatedScannedBarcode[]>(url);
  }

  static setSimulatedScannedBarcode(simulatedScannedBarcodes: SimulatedScannedBarcode[]) {
    const url = `${this.BASE_URL}/simulated-scanned-barcode`;
    return sendPostRequest(url, simulatedScannedBarcodes);
  }
}
